import { twinneeLogo } from '@/assets/svgs/gradientIcons';

/**
 * Brand SVG logo: twinneeLogo from gradientIcons.js
 */
export function TwinneeBrand({
  className = '',
  as: Tag = 'span',
  style,
  ...rest
}) {
  return (
    <Tag
      className={`inline-flex items-center justify-center select-none shrink-0 ${className}`}
      style={style}
      dangerouslySetInnerHTML={{ __html: twinneeLogo }}
      {...rest}
    />
  );
}
